<template>
<b-row class="match-height">
  <b-col :class="colSize" v-if="total_reach">
      <b-card no-body>
        <b-card-header>
          <b-card-title class="analytics-title">{{ $t('campaigns.textReachTotals') }}</b-card-title>
        </b-card-header>

        <b-card-body>
          <div class="d-flex justify-content-center">
          <component
            :is="apex_charts"
            height="275"
            :options="options_reach_by_network"
            :series="series_reach_by_network"
            v-if="change_reach_graph"
          />
          </div>
          <div
            v-for="(network,index) in legend_networks_reach_show"
            :key="index"
            :class="index < legend_networks_reach_show.length-1 ? 'mb-1':''"
            class="d-flex justify-content-between"
          >
            <div class="d-flex align-items-center">
              <b-avatar size="20px" variant="light">
                <b-img :src="getIconWhite(network.network.toLowerCase())" :class="getIconColor(network.network.toLowerCase(), false)" fluid/>
              </b-avatar>
              <span class="font-weight-bold ml-75 mr-25">{{ network.network }}</span>
              <span>- {{ numberFormat(network.reach) }}</span>
            </div>
          </div>

          <div class="d-flex align-items-center mt-1 mb-1" v-if="legend_networks_reach_expand.length > 0">
            <feather-icon
              icon="ChevronsDownIcon"
              size="24"
              v-b-toggle="'collapse-3'"
              class="icon-chevrn mt-1 cursor-pointer w-100"
              v-if="!more_reach"
            />
            <feather-icon
              v-else
              icon="ChevronsUpIcon"
              size="24"
              v-b-toggle="'collapse-3'"
              class="icon-chevrn mt-1 cursor-pointer w-100"
            />
          </div>

          <b-collapse id="collapse-3" v-model="more_reach" v-if="legend_networks_reach_expand.length > 0">
            <div
              v-for="(network,index) in legend_networks_reach_expand"
              :key="index"
              :class="index < legend_networks_reach_expand.length-1 ? 'mb-1':''"
              class="d-flex justify-content-between"
            >
              <div class="d-flex align-items-center">
                <b-avatar size="20px" variant="light">
                  <b-img :src="getIconWhite(network.network.toLowerCase())" :class="getIconColor(network.network.toLowerCase(), false)" fluid/>
                </b-avatar>
                <span class="font-weight-bold ml-75 mr-25">{{ network.network }}</span>
                <span>- {{ numberFormat(network.reach) }}</span>
              </div>
            </div>
          </b-collapse>

        </b-card-body>
      </b-card>
    </b-col>


    <b-col :class="colSize" v-if="total_views">
      <b-card no-body>
        <b-card-header>
          <b-card-title class="analytics-title">{{ $t('campaigns.textViewsTotals') }}</b-card-title>
        </b-card-header>

        <b-card-body>
          <div class="d-flex justify-content-center">
            <component
              :is="apex_charts"
              height="275"
              :options="options_views_by_network"
              :series="series_views_by_network"
              v-if="change_views_graph"
            />
          </div>
          <div
            v-for="(network,index) in legend_networks_view_show"
            :key="index"
            :class="index < legend_networks_view_show.length-1 ? 'mb-1':''"
            class="d-flex justify-content-between"
          >
            <div class="d-flex align-items-center">
              <b-avatar size="20px" variant="light">
                <b-img :src="getIconWhite(network.network.toLowerCase())" :class="getIconColor(network.network.toLowerCase(), false)" fluid/>
              </b-avatar>
              <span class="font-weight-bold ml-75 mr-25">{{ network.network }}</span>
              <span>- {{ numberFormat(network.views) }}</span>
            </div>
          </div>

          <div class="d-flex align-items-center mt-1 mb-1" v-if="legend_networks_view_expand.length > 0">
            <feather-icon
              icon="ChevronsDownIcon"
              size="24"
              v-b-toggle="'collapse-2'"
              class="icon-chevrn mt-1 cursor-pointer w-100"
              v-if="!more_networks"
            />
            <feather-icon
              v-else
              icon="ChevronsUpIcon"
              size="24"
              v-b-toggle="'collapse-2'"
              class="icon-chevrn mt-1 cursor-pointer w-100"
            />
          </div>

          <b-collapse id="collapse-2" v-model="more_networks" v-if="legend_networks_view_expand.length > 0">
            <div
              v-for="(network,index) in legend_networks_view_expand"
              :key="index"
              :class="index < legend_networks_view_expand.length-1 ? 'mb-1':''"
              class="d-flex justify-content-between"
            >
              <div class="d-flex align-items-center">
                <b-avatar size="20px" variant="light">
                  <b-img :src="getIconWhite(network.network.toLowerCase())" :class="getIconColor(network.network.toLowerCase(), false)" fluid/>
                </b-avatar>
                <span class="font-weight-bold ml-75 mr-25">{{ network.network }}</span>
                <span>- {{ numberFormat(network.views) }}</span>
              </div>
            </div>
          </b-collapse>

        </b-card-body>
      </b-card>
    </b-col>
             
    <b-col :class="colSize" v-if="counters && Object.keys(counters).length">
      <b-card class="h-100" no-body>
        <b-card-header>
          <b-card-title class="analytics-title" id="interaction-tooltip">{{ $t('campaigns.interaction') }}<feather-icon id="interaction-tooltip" icon="InfoIcon" size="20" class="text-dark cursor-pointer ml-1"></feather-icon></b-card-title>
        </b-card-header>
        <b-popover triggers="hover" placement="top" target="interaction-tooltip">
          <div v-html="$t('campaigns.interactionTooltip')"></div>
        </b-popover>
        <b-card-body class="d-flex flex-column justify-content-center h-100">
          <b-row>
            <!-- Likes -->
            <b-col cols="6" class="d-flex flex-column align-items-center mb-4">
              <b-icon id="likes-icon" icon="heart-fill" font-scale="2" class="mb-1"></b-icon>
              <b-popover triggers="hover" placement="top" target="likes-icon">
                <template #default>
                  <div v-html="$t('campaigns.likesTooltip')"></div>
                </template>
              </b-popover>
              <span>{{ numberFormat(counters.number_of_likes) }}</span>
            </b-col>

            <!-- Comments -->
            <b-col cols="6" class="d-flex flex-column align-items-center mb-4">
              <b-icon id="comments-icon" icon="chat-fill" font-scale="2" class="mb-1"></b-icon>
              <b-popover triggers="hover" placement="top" target="comments-icon">
                <template #default>
                  <div v-html="$t('campaigns.commentsTooltip')"></div>
                </template>
              </b-popover>
              <span>{{ numberFormat(counters.number_of_comments) }}</span>
            </b-col>

            <!-- Shares -->
            <b-col cols="6" class="d-flex flex-column align-items-center mb-2">
              <b-icon id="shares-icon" icon="share-fill" font-scale="2" class="mb-1"></b-icon>
              <b-popover triggers="hover" placement="top" target="shares-icon">
                <template #default>
                  <div v-html="$t('campaigns.sharesTooltip')"></div>
                </template>
              </b-popover>
              <span>{{ numberFormat(counters.number_of_shares) }}</span>
            </b-col>

            <!-- Times Saved -->
            <b-col cols="6" class="d-flex flex-column align-items-center mb-2">
              <b-icon id="saved-icon" icon="bookmark-fill" font-scale="2" class="mb-1"></b-icon>
              <b-popover triggers="hover" placement="top" target="saved-icon">
                <template #default>
                  <div v-html="$t('campaigns.shavesTooltip')"></div>
                </template>
              </b-popover>
              <span>{{ numberFormat(counters.number_of_times_saved) }}</span>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>

</b-row>
</template>
<script>
import {BRow, BCol, BCard, BCardHeader, BCardTitle, BCardBody, BImg, BAvatar, BCollapse, VBToggle, BPopover} from 'bootstrap-vue'
import { numberFormat, decimalFixed} from '@/libs/utils/formats';
import { getDropdownNetworks, getClassNetworkSpan, getColor, getIconWhite, getIconColor } from '@/libs/utils/icons';

export default {
  name: 'DonutsInteractions',
  directives: {
    'b-toggle': VBToggle
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BImg,
    BAvatar,
    BCollapse,
    VBToggle,
    BPopover
  },
  props: {
    counters: {
      required: true
    },
    networks: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      getColor,
      getIconWhite,
      getIconColor,
      numberFormat,
      apex_charts: null,
      total_views: 0,
      series_views_by_network: [],
      options_views_by_network: {
        chart: {
          type: 'donut',
          toolbar: {
            show: false,
          },
        },
        labels: [],
        colors: [],
        yaxis: {
          labels: {
            formatter(val) {
              return `${val}%`
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: { show: false },
        comparedResult: [2, -3, 8],
        stroke: { width: 0 },
        plotOptions: {
          pie: {
            startAngle: 0,
            donut: {
              labels: {
                show: true,
                name: {
                  offsetY: 15,
                },
                value: {
                  offsetY: -15,
                  formatter(val) {
                    return `${val}%`
                  },
                },
                total: {
                  show: true,
                  offsetY: 15,
                  label: this.$t('campaigns.totalViews'),
                  formatter: () => { return `${numberFormat(this.total_views)}` },
                },
              },
            },
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: '100%'
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ]
      },
      change_views_graph: false,
      legend_views_networks: [],
      legend_networks_view_show: [],
      legend_networks_view_expand: [],
      more_networks: false,
      total_reach: 0,
      series_reach_by_network: [],
      options_reach_by_network: {
        chart: {
          type: 'donut',
          toolbar: {
            show: false,
          },
        },
        labels: [],
        colors: [],
        yaxis: {
          labels: {
            formatter(val) {
              return `${val}%`
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: { show: false },
        comparedResult: [2, -3, 8],
        stroke: { width: 0 },
        plotOptions: {
          pie: {
            startAngle: 0,
            donut: {
              labels: {
                show: true,
                name: {
                  offsetY: 15,
                },
                value: {
                  offsetY: -15,
                  formatter(val) {
                    return `${val}%`
                  },
                },
                total: {
                  show: true,
                  offsetY: 15,
                  label: this.$t('campaigns.totalReach'),
                  formatter: () => { return `${numberFormat(this.total_reach)}` },
                },
              },
            },
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: '100%'
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ]
      },
      change_reach_graph: false,
      legend_reach_networks: [],
      legend_networks_reach_show: [],
      legend_networks_reach_expand: [],
      more_reach: false,
    }
  },
  created() {
    this.networks.forEach(network_summary => {
      if (network_summary.total_views > 0) {
        this.total_views += network_summary.total_views;
      }
      if (network_summary.total_reach > 0) {
        this.total_reach += network_summary.total_reach;
      }
    });

    this.formatViewsByNetwork();
    this.formatReachByNetwork();
  },
  async mounted() {
    this.apex_charts = (await import('vue-apexcharts')).default;
  },
  computed: {
    colSize() {
      let count = 0;
      if (this.total_reach) count++;
      if (this.total_views) count++;
      if (this.counters && Object.keys(this.counters).length) count++;

      if (count === 1) return 'col-12';
      if (count === 2) return 'col-12 col-lg-6 col-xl-6 col-xxl-6';
      return 'col-12 col-lg-4 col-xl-4 col-xxl-4';
    }
  },
  methods: {
    formatViewsByNetwork() {
      const option_networks = getDropdownNetworks();
      const colors = [];
      const labels = [];
      const series = [];
      const legend_views_networks = [];

      this.networks.forEach(network_summary => {
        if (network_summary.total_views > 0) {
          const network_name = option_networks.find(net => net.value === network_summary.network);
          const views = network_summary.total_views;
          const percentage = decimalFixed((views * 100) / this.total_views, 2);

          labels.push(network_name.network);
          series.push(parseFloat(percentage));
          colors.push(getColor(network_summary.network,true));

          legend_views_networks.push({
            network: network_name.network,
            icon: getClassNetworkSpan(network_summary.network),
            color: getColor(network_summary.network,true),
            views,
            percentage
          });
        }
      });

      this.legend_views_networks = legend_views_networks;

      this.legend_networks_view_show = legend_views_networks.slice(0, 3);
      this.legend_networks_view_expand = legend_views_networks.slice(3);

      this.series_views_by_network = series;
      this.options_views_by_network.labels = labels;
      this.options_views_by_network.colors = colors;

      setTimeout(() => {
        this.change_views_graph = true;
      }, 50);
    },
    formatReachByNetwork() {
      const option_networks = getDropdownNetworks();
      const colors = [];
      const labels = [];
      const series = [];
      const legend_reach_networks = [];

      this.networks.forEach(network_summary => {
        if (network_summary.total_reach > 0) {
          const network_name = option_networks.find(net => net.value === network_summary.network);
          const reach = network_summary.total_reach;
          const percentage = decimalFixed((reach * 100) / this.total_reach, 2);

          labels.push(network_name.network);
          series.push(parseFloat(percentage));
          colors.push(getColor(network_summary.network,true));

          legend_reach_networks.push({
            network: network_name.network,
            icon: getClassNetworkSpan(network_summary.network),
            color: getColor(network_summary.network,true),
            reach,
            percentage
          });
        }
      });

      this.legend_reach_networks = legend_reach_networks;

      this.legend_networks_reach_show = legend_reach_networks.slice(0, 3);
      this.legend_networks_reach_expand = legend_reach_networks.slice(3);

      this.series_reach_by_network = series;
      this.options_reach_by_network.labels = labels;
      this.options_reach_by_network.colors = colors;

      setTimeout(() => {
        this.change_reach_graph = true;
      }, 50);
    },

  },
}
</script>
  